import React, {useState, useEffect} from 'react';
import moment from 'moment'
import {get} from 'lodash';

import {CpIcon, CpButton} from 'canopy-styleguide!sofe';
import canopyUrls from 'canopy-urls!sofe';

import styles from '../client-menu.styles.css';
import { ensurePageReload } from '../../common/url-helpers.js';
import {getSelectUser, postLoginRedirect} from './switch-user.resource';
import ClientMenuLinks from './client-menu-links.component'

export default function ClientMenuContent(props) {
  const {
    user,
    clients,
    activeClient,
    hasCanopyPayments,
    entities,
    userEntity,
    customLinks,
    companyWebsiteLink,
    close,
  } = props

  const [switchUserDialog, setSwitchUserDialog] = useState(false)
  const [switchUser, setSwitchUser] = useState(null)

  const logoutUrl = ensurePageReload(
    `${canopyUrls.getAuthUrl()}/#/logout?redirect_url=${encodeURIComponent(window.location.origin)}`
  );
  const activeClientList = clients.filter(client => client.id !== activeClient?.id)

  useEffect(() => {
    if (switchUser) {
      const subscription = getSelectUser(switchUser.id)
      .subscribe(results => {
          postLoginRedirect(results.instance_url ? results.instance_url : window.location.origin)
        },
        (e) => {
          if (e.status === 418) {
            const redirectUrl = get(e, 'data.body.redirect_url')
            if (redirectUrl) {
              window.location.href = redirectUrl
            } else {
              throw new Error(`POST /token responded with 418 to indicate user is on wrong domain, but directory service did not specify what the correct domain is`)
            }
          }
        }
      )
      return () => {
        subscription.unsubscribe()
      }
    }
  }, [switchUser]);

  const standardDialogContent = () => {
    return (
      <div className="cp-select-list" onClick={close}>
        {activeClientList.map(client => (
          <a className={`cps-ellipsis`} href={`/#/client/${client.id}`} key={client.id}>
            <div className="cps-label-square +medium cps-dropdown-menu__icon">
              <div className={`cps-center-vertical ${styles.initialsBlock}`}>{client.initials}</div>
            </div >
            <span className='cps-ellipsis'>{client.name}</span>
          </a>
        ))}
        {(customLinks?.length > 0 || !!companyWebsiteLink?.enabled) && (
          <ClientMenuLinks
            customLinks={customLinks}
            companyWebsiteLink={companyWebsiteLink}
            showBorder={activeClientList?.length > 0}
          />
        )}
        <a href={`/#/global-settings/user/${user.id}`} className='cps-body'>User settings</a>
        {hasCanopyPayments && (
          <a href={`/#/client/${activeClient?.id}/billing/payment-settings`}>Payment settings</a>
        )}
        {entities?.length > 1 && (
          <button onClick={(e) => {
            e.stopPropagation() // Prevent dropdown closure
            setSwitchUserDialog(true)
          }}>
            <div className='cp-select-list__content'>
              <div className='cps-body'>Switch Firm</div>
              <div className='cps-wt-semibold cps-caption cps-ellipsis'>{userEntity.company_name}</div>
            </div>
            <CpIcon className='cp-select-list__icon-right' name="caret-large-right"/>
          </button>
        )}
        <a href={logoutUrl} className='cps-body'>Sign out</a>
      </div>
    )
  }

  const switchUserDialogContent = () => {
    return (
      <div className={`cp-select-list cps-text-ellipsis`} onClick={close}>
        <button onClick={(e) => {
          e.stopPropagation() // Prevent dropdown closure
          setSwitchUserDialog(false)
        }}>
          <CpIcon className='cp-select-list__icon-left' name="caret-large-left"/>
          <div className='cps-body'>Back</div>
        </button>
        {entities && entities
          .filter((e) => {
            return e.id !== user.id
          })
          .map(entity => {
            const lastLogin = entity.lastLogin ? `${moment(user.lastLogin).format('MM/DD/YYYY')}` : 'never'
            return (
              <CpButton btnType='unstyled' key={entity.id} onClick={() => setSwitchUser(entity)}>
                <div className='cp-select-list__content'>
                  <div className='cps-body cps-ellipsis'>{entity.company_name}</div>
                  <div className={`${styles.lineSecondaryText} cps-caption cps-ellipsis`}>
                    Client Portal - Last Login {lastLogin}
                  </div>
                </div>
              </CpButton>
            )
          }
        )}
      </div>
    )
  }

  if (switchUserDialog) {
    return switchUserDialogContent()
  } else {
    return standardDialogContent()
  }
}
